export const environment = {
  production: true,
  appId: "02a42623-0d2a-4948-917e-d767d8f706dc",
  baseUrl: "https://amsuiteservices.neworg.net/",
  baseUrlApi: "https://amsuiteservices.neworg.net/api",
  demoUrlApi: "https://amsuiteservicesdemo.neworg.net",

  baseUrlAD: "https://amsuiteservicesad.neworg.net/",
  baseUrlADApi: "https://amsuiteservicesad.neworg.net/api",

  devUrlApi: "https://amsuiteservicesdev.neworg.net/api",
  devUrlADApi: "https://amsuiteservicesaddev.neworg.net/api",

  baseUrlADB2C: "https://amsuiteservices2.neworg.net/",
  baseUrlADB2CApi: "https://amsuiteservices2.neworg.net/api",


  routes: {
    config: {
      useHash: false,
      enableTracing: false
    }
  },
  appInsights: {
    instrumentationKey: '02ddf4cb-9c4d-44fc-bb74-a3ceb0900e93'
  },
  cryptingKey: "T7LiYWa2U8SWchbYMXRcYP3Y67w7pawt",
};
